document.querySelectorAll('[data-carousel]').forEach(function(c){var t=c.querySelector('.carousel__track');
c.querySelector('[data-prev]').onclick=function(){t.scrollBy({left:-t.clientWidth*.8,behavior:'smooth'})};
c.querySelector('[data-next]').onclick=function(){t.scrollBy({left:t.clientWidth*.8,behavior:'smooth'})}});
document.querySelectorAll('[data-countdown]').forEach(function(el){var end=new Date(el.dataset.countdown).getTime();
function p(n){return n<10?'0'+n:n}
function tick(){var d=end-Date.now();if(isNaN(end)||d<=0){el.hidden=true;return}
var v=[Math.floor(d/864e5),Math.floor(d/36e5)%24,Math.floor(d/6e4)%60,Math.floor(d/1e3)%60];
el.querySelectorAll('b').forEach(function(b,i){b.textContent=p(v[i])})}
tick();setInterval(tick,1000)});
document.querySelectorAll('[data-copy]').forEach(function(b){b.onclick=function(){var l=location.origin;(navigator.clipboard?navigator.clipboard.writeText(l):Promise.resolve()).then(function(){var s=b.querySelector('span');if(s)s.textContent='Copied!'})}});

/* waitlist popup: opens right as the page loads, and once more when the visitor reaches the product section (unless they already joined).
   The floating tab is always available. Add ?wl=1 to the address to reset this browser and test again. */
(function(){
var d=document.getElementById('wl-dialog'),tab=document.querySelector('.wl-tab');if(!d||typeof d.showModal!=='function')return;
var K='boomi_wl';
if(/[?&]wl=1/.test(location.search)){try{localStorage.removeItem(K);sessionStorage.removeItem('boomi_wl_auto')}catch(e){}}
function ls(){try{return JSON.parse(localStorage.getItem(K)||'{}')}catch(e){return{}}}
function sv(o){try{var s=ls();for(var k in o)s[k]=o[k];localStorage.setItem(K,JSON.stringify(s))}catch(e){}}
var joined=!!ls().joined;
function tabShow(v){if(tab)tab.hidden=!v}
function open(){if(d.open)return;tabShow(false);d.showModal();setTimeout(function(){var i=d.querySelector('input[type=email]');if(i&&!d.classList.contains('is-done'))i.focus()},60)}
function done(){joined=true;sv({joined:true});d.classList.add('is-done');tabShow(false)}
document.addEventListener('click',function(e){
 if(e.target.closest('[data-open-waitlist]')){e.preventDefault();open()}
 if(e.target.closest('[data-close-waitlist]'))d.close();
 if(e.target===d)d.close()});
d.addEventListener('close',function(){if(!joined)tabShow(true)});
var f=d.querySelector('form');
if(f)f.addEventListener('submit',function(e){e.preventDefault();var b=f.querySelector('button[type=submit]');if(b){b.disabled=true;b.textContent='Joining...'}
 fetch(f.action,{method:'POST',body:new URLSearchParams(new FormData(f)),credentials:'same-origin'}).then(function(r){if(r.ok&&r.url.indexOf('challenge')<0)done();else f.submit()}).catch(function(){f.submit()})});
if(document.documentElement.dataset.wlPosted){done();open();try{history.replaceState(null,'',location.pathname)}catch(e){}return}
if(joined){tabShow(false);return}
tabShow(true);
var trig=d.getAttribute('data-trigger')||'both',firedLoad=false,firedProd=false;
if(trig==='load'||trig==='both')setTimeout(function(){if(!firedLoad&&!joined&&!d.open){firedLoad=true;open()}},400);
if(trig==='timer')setTimeout(function(){if(!joined&&!d.open)open()},8000);
if(trig==='product'||trig==='both'){var prod=document.getElementById('product');
 if(prod&&'IntersectionObserver' in window){var io=new IntersectionObserver(function(es){if(!es[0].isIntersecting||firedProd||joined||d.open)return;firedProd=true;io.disconnect();setTimeout(function(){if(!joined&&!d.open)open()},400)},{rootMargin:'0px 0px -35% 0px'});io.observe(prod)}}
})();

/* flip cards: spice jars + story tiles */
document.querySelectorAll('[data-flip]').forEach(function(c){
 function t(){var on=c.classList.toggle('is-flipped');c.setAttribute('aria-pressed',on)}
 c.addEventListener('click',t);
 c.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();t()}})});

/* footer: share with friends (phone share sheet if available, otherwise copies the link) */
document.querySelectorAll('[data-share]').forEach(function(b){
 var s=b.querySelector('span'),t=s?s.textContent:'';
 b.addEventListener('click',function(){
  var u=location.origin,done=function(){if(s){s.textContent='Link copied!';setTimeout(function(){s.textContent=t},1800)}};
  if(navigator.share){navigator.share({title:document.title,url:u}).catch(function(){})}
  else if(navigator.clipboard){navigator.clipboard.writeText(u).then(done)}
  else{done()}})});
